"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _canadianSalesTax = require("canadian-sales-tax");

var _canadianSalesTax2 = _interopRequireDefault(_canadianSalesTax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Canadian sales taxes
// AE_CANADIAN_TAXES
/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

exports.default = _lodash2.default.transform(_canadianSalesTax2.default, function (result, region, key) {
  result[key] = {
    name: region.name,
    taxes: _lodash2.default.map(region.taxes, function (tax) {
      return {
        code: tax.code,
        tax: tax.tax,
        // Sales taxes in Canada are always a percentage.
        percentage: true
      };
    })
  };
});
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/AE_CANADIAN_TAXES.js
// module id = 57
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54